import React, {useEffect, useState, useRef} from 'react';
import {Descriptions, InputNumber, Form, Flex, Button, Select} from 'antd';
import {PlusOutlined, MinusCircleOutlined} from '@ant-design/icons';
import styles from './index.less';

/**
 * 按量套餐设置
 */
export default function (props) {
  const countFormRef = React.useRef(null);
  const agentFormRef = React.useRef(null);
  const [month, setMonth] = useState(props?.data?.option?.defaultValue?.month);
  const [countPrice, setCountPrice] = useState({
    countStep: props?.data?.option?.defaultValue?.countPrice?.map((eachStep)=>{
      return {
        ...eachStep,
        cost: eachStep.cost?eachStep.cost/100:null,
      }
    })
  });
  const [agentPrice, setAgentPrice] = useState({
    countStep: props?.data?.option?.defaultValue?.agentPrice?.map((eachStep)=>{
      return {
        ...eachStep,
        cost: eachStep.cost?eachStep.cost/100:null,
      }
    })
  });

  useEffect(() => {
    props.verification(props.data, {
      month: month,
      countPrice: countPrice?.countStep?.map((eachStep)=>{
        if(!eachStep){
          return eachStep
        }
        return {
          ...eachStep,
          cost: eachStep.cost?Math.round(eachStep.cost * 100):null,
        }
      }),
      agentPrice: agentPrice?.countStep?.map((eachStep)=>{
        if(!eachStep){
          return eachStep
        }

        return {
          ...eachStep,
          cost: eachStep.cost?Math.round(eachStep.cost * 100):null,
        }
      }),
    })
  }, [props.data, month, countPrice, agentPrice])

  return <Descriptions
    bordered
    column={1}
    size={"small"}
    labelStyle={{width: "100px"}}
  >
    <Descriptions.item label={'算力档位'}>
      <Form
        ref={countFormRef}
        name="countPrice"
        initialValues={countPrice}
        autoComplete="off"
        className={styles.formDiy}
        onValuesChange={(value)=>{
          setCountPrice(countFormRef.current?.getFieldsValue(true))
        }}
      >
        <Form.List name="countStep">
          {(fields, {add, remove}) => (
            <>
              {fields.map(({key, name, ...restField}, index) => (
                <Flex key={key} gap={10} align={"center"}>
                  <Flex
                    gap={5} align={"center"}
                  >
                    <span>档位{index + 1}</span>:
                    <Form.Item
                      {...restField}
                      name={[name, 'startCount']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <InputNumber
                        size={"small"}
                        min={1}
                        controls={false}
                        step={0}
                      />
                    </Form.Item>
                    ~
                    <Form.Item
                      {...restField}
                      name={[name, 'endCount']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <InputNumber
                        size={"small"}
                        min={1}
                        controls={false}
                        step={0}
                      />
                    </Form.Item>
                    <span>次</span>
                  </Flex>
                  <Flex
                    gap={5} align={"center"}
                  >
                    <span>每</span>
                    <Form.Item
                      {...restField}
                      name={[name, 'perN']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <Select
                        size={"small"}
                        placeholder={"请选择"}
                        options={[
                          {
                            label: '十次',
                            value: 10,
                          },
                          {
                            label: '百次',
                            value: 100,
                          },
                          {
                            label: '千次',
                            value: 1000,
                          },
                          {
                            label: '万次',
                            value: 10000,
                          }
                        ]}
                      >

                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'cost']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <InputNumber
                        precision={2}
                        size={"small"}
                        min={0}
                        controls={false}
                        step={0}
                      />
                    </Form.Item>
                    <span>灵能</span>
                  </Flex>
                  <MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'red' }} />
                </Flex>
              ))}
              <Form.Item>
                <Button type="link" onClick={() => add()} block icon={<PlusOutlined/>}>
                  新增算力档位
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Descriptions.item>
    <Descriptions.item label={'Agent档位'}>
      <Form
        ref={agentFormRef}
        name="agentPrice"
        initialValues={agentPrice}
        autoComplete="off"
        className={styles.formDiy}
        onValuesChange={(value)=>{
          setAgentPrice(agentFormRef.current?.getFieldsValue(true))
        }}
      >
        <Form.List name="countStep">
          {(fields, {add, remove}) => (
            <>
              {fields.map(({key, name, ...restField}, index) => (
                <Flex key={key} gap={10} align={"center"}>
                  <Flex
                    gap={5} align={"center"}
                  >
                    <span>档位{index + 1}</span>:
                    <Form.Item
                      {...restField}
                      name={[name, 'startCount']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <InputNumber
                        size={"small"}
                        min={1}
                        controls={false}
                        step={0}
                      />
                    </Form.Item>
                    ~
                    <Form.Item
                      {...restField}
                      name={[name, 'endCount']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <InputNumber
                        size={"small"}
                        min={1}
                        controls={false}
                        step={0}
                      />
                    </Form.Item>
                    <span>次</span>
                  </Flex>
                  <Flex
                    gap={5} align={"center"}
                  >
                    <span>每</span>
                    <Form.Item
                      {...restField}
                      name={[name, 'perN']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <Select
                        size={"small"}
                        placeholder={"请选择"}
                        options={[
                          {
                            label: '十次',
                            value: 10,
                          },
                          {
                            label: '百次',
                            value: 100,
                          },
                          {
                            label: '千次',
                            value: 1000,
                          },
                          {
                            label: '万次',
                            value: 10000,
                          }
                        ]}
                      >

                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'cost']}
                      rules={[{required: true, message: '请输入'}]}
                    >
                      <InputNumber
                        precision={2}
                        size={"small"}
                        min={0}
                        controls={false}
                        step={0}
                      />
                    </Form.Item>
                    <span>灵能</span>
                  </Flex>
                  <MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'red' }} />
                </Flex>
              ))}
              <Form.Item>
                <Button type="link" onClick={() => add()} block icon={<PlusOutlined/>}>
                  新增Agent档位
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Descriptions.item>
    <Descriptions.item label={'有效期'}>
      <InputNumber
        style={{width: "100%"}}
        min={1}
        max={12}
        step={1}
        precision={0}
        controls={false}
        placeholder={'请填写有效期'}
        addonAfter={"个月"}
        value={month}
        onChange={(value) => {
          setMonth(value)
        }}
      />
    </Descriptions.item>
  </Descriptions>
}